import { SET_RELOAD } from '../actions/apolloActions'

export default function (state = null, action) {
  switch (action.type) {
    case SET_RELOAD:
      return { ...state, refetch: action.payLoad }
    default:
      return { ...state, refetch: false }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/apolloReducer.js